import React, { Component } from 'react';
import { Main, Heading, SubHeading } from '../../styles/style';
import { withRouter } from 'react-router-dom';

class ResetPasswordSuccess extends Component {
	render() {
    return (
      <Main>
        <SubHeading>Check Your Inbox</SubHeading>
        <p>We sent you an email with a link to reset your password.</p>
        <p>If you do not receive the email, or encounter other issues, please contact <a href="mailto:host@onthetablebc.com">host@onthetablebc.com</a> for assistance.</p>
      </Main>
    )
  }
}

export default withRouter(ResetPasswordSuccess)
